import React, { useState, useEffect, useRef } from "react";
import "./retailerlist.scss";
import Sidebar from "../Sidebar";
import { pgmRetailerListAction, retailersearchCriteriaAction } from "../../actions/pgmlistAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { decode, encode } from "base-64";
import Header from "../../component/loaderComponent/Header/Header";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Nopermission from "../../component/loaderComponent/NoPermissions/Nopermission";
import Cookies from "js-cookie";
import { notify } from '../../services/notification';
import Validation from "../../constants/validation/Validation";
import { useSelector } from "react-redux";
import { categoryAction, pgmpageAction } from "../../actions/pgmlistAction";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { dowloadRetaierlistAction } from "../../actions/exceldownloadAction";
import RetailerListSkeleton from "../../component/SkeletonLoader/RetailerListSkeleton";
import { constant } from "../../constants/constant";
import { isMoreThanThreeMonths } from "../../constants/dateTimeUtils/dateTimeUtils";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { HiMenu, HiX } from "react-icons/hi";
import useMobileView from "../../constants/useMobileView";
import { formatDate } from "../../constants/validation/FormateDate";
import moment from "moment/moment";


function RetailerList(props) {

  const [state, setDataState] = useState({
    RetailerData: [],
  });
  const categorydata = useSelector((state) => state.pgmCategory);
  const retailerSearchdata = useSelector((state) => state.retailerSearch);
  const [states, setDataStates] = useState({
    nameValue: retailerSearchdata?.retailerSearchdata?.data?.value
  })
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(categorydata.page);
  const { isSidebarOpen, toggleSidebar } = useMobileView();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isInitialMount = useRef(true);
  const prevDatesRef = useRef({ fromDate: '', toDate: '' });

  const [criteria, setcriteria] = useState(retailerSearchdata?.retailerSearchdata?.data?.criteria ? retailerSearchdata?.retailerSearchdata?.data?.criteria : "");
  const [activeStatus, setActiveStatus] = useState("Pending");
  const [activeButton, setActiveButton] = useState("Pending");
  const [isLoading, setLoading] = useState(false);
  const [nodata, setNodata] = useState(false);
  const [fromDate, setFromDate] = useState(retailerSearchdata?.retailerSearchdata?.data?.fromDate);
  const [toDate, setToDate] = useState(retailerSearchdata?.retailerSearchdata?.data?.toDate);
  const [paginationListcount, setpaginationListcount] = useState(0);
  const [isRetailerLinked, setIsRetailerLinked] = useState("");
  const [activeRetailerType, setActiveRetailerType] = useState("all");
  const data = decode(Cookies.get('permissions'));
  const permissions = data?.includes("pgm_registration_approval");
  const RECORDS_PER_PAGE = 10;


  async function handleCriteriaChange(event) {
    dispatch(pgmpageAction(1));
    setDataStates({
      ...states,
      nameValue: '',
    });
    setcriteria(event.target.value)
    setPage(1);
    var seardata = {
      criteria: event.target.value,
      value: "",
    };
    dispatch(retailersearchCriteriaAction(seardata));
    // var response = await dispatch(pgmRetailerListAction(page, activeStatus));
    // if (response && response.status === 200) {
    //   setNodata(false);

    //   const totalCount = response.data.count || 0;
    //   const totalPages = Math.ceil(totalCount / RECORDS_PER_PAGE);
    //   setCount(totalPages);

    //   setDataState({
    //     RetailerData: response.data.results?.data || [],
    //   });
    // }
  }

  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataStates({
      ...states,
      [evt.target.name]: value.replace(/^ +/gm, ''),
    });
    if (value.length === 0) {
      window.location.reload()
    }
  };

  const handleRetailerTypeClick = async (type) => {
    setActiveRetailerType(type);
    setPage(1);
    dispatch(pgmpageAction(1));

    if (type === "all") {
      setIsRetailerLinked("");
    } else if (type === "linked") {
      await setIsRetailerLinked("true");
    } else if (type === "notlinked") {
      await setIsRetailerLinked("false"); 
    }
  };

  // Consolidated useEffect to prevent multiple API calls
  useEffect(() => {
    if (isInitialMount.current) {
      // On initial mount, fetch data only once
      isInitialMount.current = false;
      FetchRetailerDetails(activeStatus);
    } else {
      // On subsequent updates, fetch data when page, activeStatus or isRetailerLinked changes
      // This will work with or without date filters
      FetchRetailerDetails(activeStatus);
    }
  }, [page, activeStatus, isRetailerLinked]);

  // New useEffect to handle automatic reset when dates are cleared
  useEffect(() => {
    // Skip on initial mount
    if (isInitialMount.current) {
      prevDatesRef.current = { fromDate, toDate };
      return;
    }

    // Check if both dates are now empty AND at least one was previously set
    const bothDatesCleared = !fromDate && !toDate;
    const hadPreviousDates = prevDatesRef.current.fromDate || prevDatesRef.current.toDate;

    if (bothDatesCleared && hadPreviousDates) {
      // Reset all filters and fetch unfiltered data
      const resetPage = 1;
      setPage(resetPage);
      dispatch(pgmpageAction(resetPage));

      // Clear other filters
      setcriteria('');
      setDataStates({ nameValue: '' });
      setIsRetailerLinked('');
      setActiveRetailerType('all');

      // Clear Redux search criteria
      dispatch(retailersearchCriteriaAction({
        criteria: '',
        value: '',
        fromDate: '',
        toDate: ''
      }));

      // Fetch all unfiltered data at page 1
      dispatch(pgmRetailerListAction(resetPage, activeStatus, '', '', '', '', ''))
        .then(response => {
          if (response?.status === 200) {
            setLoading(false);
            setNodata(false);
            const totalCount = response.data.count || 0;
            const totalPages = Math.ceil(totalCount / RECORDS_PER_PAGE);
            setCount(totalPages);
            setDataState({
              RetailerData: response.data.results?.data || [],
            });
            setpaginationListcount(totalCount);
          }
        });
    }

    // Update previous dates
    prevDatesRef.current = { fromDate, toDate };
  }, [fromDate, toDate]);

  const retailerDetails = (Id) => {
    window.scroll(0, 0);
    const encodeid = encode(Id);
    navigate(`/retailerDetails/${encodeid}`);
  };


  async function FetchRetailerDetails(para) {
    setLoading(true);
    let response;
    const nameValue = states.nameValue || "";
    const criteriaValue = criteria || "";
    response = await dispatch(pgmRetailerListAction(page, activeStatus, nameValue, criteriaValue, fromDate, toDate, isRetailerLinked));
    if (response?.status === 200 && response.data) {
      setLoading(false);
      setNodata(false);
      const totalCount = response.data.count;
      const pageCount = Math.ceil(totalCount / RECORDS_PER_PAGE);
      setCount(pageCount);
      setDataState({
        RetailerData: response.data.results.data,
      });
      setpaginationListcount(totalCount);
    } else {
      setLoading(false);
      setNodata(true);
    }

  }
  const startItem = state?.RetailerData?.length === 0 ? 0 : (page - 1) * constant.paginationCount + 1;
  const endItem = Math.min(page * constant.paginationCount, paginationListcount);

  const handlePaginationChange = (event, value) => {
    dispatch(pgmpageAction(value));
    setPage(value);
  };
  async function filterSearch() {
    setLoading(true);

    // Reset to page 1 for new search
    const searchPage = 1;
    setPage(searchPage);
    dispatch(pgmpageAction(searchPage));

    var seardata = {
      criteria: criteria,
      value: states.nameValue,
      fromDate: fromDate,
      toDate: toDate
    };
    dispatch(retailersearchCriteriaAction(seardata));
    let response = await dispatch(pgmRetailerListAction(searchPage, activeStatus, states.nameValue, criteria, fromDate, toDate, isRetailerLinked));
    if (response?.status === 200) {
      setLoading(false);
      setNodata(false);

      const totalCount = response.data.count || 0;
      const totalPages = Math.ceil(totalCount / RECORDS_PER_PAGE);
      setCount(totalPages);

      setDataState({
        RetailerData: response.data.results?.data || [],
      });

      setpaginationListcount(totalCount);
    }

  }


  async function downloadRetailerList() {
    try {
      if (!isMoreThanThreeMonths(fromDate, toDate)) {
        notify.error("Date range cannot exceed 3 months");
        return;
      }
      let queryParams = new URLSearchParams();
      queryParams.append("user_type", "retailer");
      queryParams.append("page", page);
      queryParams.append("page_size", 10);

      if (isRetailerLinked) {
        queryParams.append("is_retailer_linked", isRetailerLinked);
      }

      if (criteria !== "all" && states?.nameValue) queryParams.append(criteria, states?.nameValue);

      if (fromDate && toDate) {
        queryParams.append("created_from", fromDate);
        queryParams.append("created_to", toDate);
      }

      const fileBlob = await dispatch(dowloadRetaierlistAction(queryParams));

      if (fileBlob) {
        const messageText = await fileBlob.text();
        const jsonText = JSON.parse(messageText);
        notify.success(jsonText.message || 'Success');
      }
    } catch (error) {
      notify.error('Error downloading file:', error);
    }
  }

  const today = formatDate(new Date());

  const handleDateChange = (event) => {
    const { name, value } = event.target;
    if (name == 'fromDate') setFromDate(value);
    else setToDate(value);
  }

  return (
    <div className="list-3w">
      <div className="retailer-container">
        <div className="retailer-list-container">
          <div className="pgm_list_container_s">
            <Header title="Retailer List" />
            {isLoading ? (
              <RetailerListSkeleton />
            ) : (
              <>
                {permissions === true ?
                  <div className="Pgmmargin_div">
                    <div className="retailer-type-buttons">
                      <button
                        className={activeRetailerType === "all" ? "active retailer-btn-all" : "retailer-btn-all"}
                        onClick={() => handleRetailerTypeClick("all")}
                      >
                        All
                      </button>
                      <button
                        className={activeRetailerType === "linked" ? "active retailer-btn-linked" : "retailer-btn-linked"}
                        onClick={() => handleRetailerTypeClick("linked")}
                      >
                        Linked with POMS
                      </button>
                      <button
                        className={activeRetailerType === "notlinked" ? "active retailer-btn-notlinked" : "retailer-btn-notlinked"}
                        onClick={() => handleRetailerTypeClick("notlinked")}
                      >
                        Not Linked with POMS
                      </button>
                    </div>
                    <div className="retailer-list-input-wrappers">
                      <div className="textfield_dropdown">
                        <select name="criteria" id="cars" className="text_fileddropdowns" value={criteria} onChange={handleCriteriaChange}>
                          <option value="">Select Criteria</option>
                          <option value="name">Retailer Name</option>
                          <option value="aps_name">Aps Name</option>
                          <option value="mobile_number">Mobile Number</option>
                          <option value="pincode">Pincode</option>
                          <option value="garage_name">Shop Name</option>
                          <option value="pgm_id">Retailer ID</option>
                        </select>
                        {criteria === "pincode" ? (
                          <input
                            type="search"
                            className="input_Text_EnterValue"
                            placeholder="Enter a Value"
                            name="nameValue"
                            maxLength={6}
                            value={states.nameValue}
                            disabled={!criteria}
                            onChange={handleChange}
                            onKeyPress={(e) => Validation.numberinputValidator(e)}
                          />
                        ) : criteria === "mobile_number" ? (
                          <input
                            type="search"
                            className="input_Text_EnterValue"
                            placeholder="Enter a Value"
                            name="nameValue"
                            maxLength={10}
                            value={states.nameValue}
                            disabled={!criteria}
                            onChange={handleChange}
                            onKeyPress={(e) => Validation.numberinputValidator(e)}
                          />
                        ) : (
                          <input
                            type="search"
                            className="input_Text_EnterValue"
                            placeholder="Enter a Value"
                            name="nameValue"
                            disabled={!criteria}
                            value={states.nameValue}
                            onChange={handleChange}
                          />
                        )}
                        <div className="from-to-date">
                          <div className="date-container">
                            <label className="date-label">
                              From Date<span className="required">*</span>
                            </label>
                            <input
                              max={today}
                              type="date"
                              id="date"
                              value={fromDate}
                              placeholder="dd/mm/yy"
                              name="fromDate"
                              onChange={handleDateChange}
                              className="retailer-date-input-field"
                            />
                          </div>
                          <div className="date-container">
                            <label className="date-label">
                              To Date<span className="required">*</span>
                            </label>
                            <input
                              type="date"
                              id="date"
                              min={fromDate}
                              max={today}
                              value={toDate}
                              placeholder="dd/mm/yy"
                              name="toDate"
                              onChange={handleDateChange}
                              className="retailer-date-input-field"
                              disabled={!fromDate}
                            />
                          </div>
                        </div>
                        <button className="pgm_buttonsearchs"
                          disabled={!((criteria && states.nameValue) || (fromDate && toDate))}
                          onClick={filterSearch}>Search</button>
                      </div>
                      <div className="pgmbutton">
                        <div className="button-group-pgmlist">
                        </div>
                        <button className="download_excel" onClick={downloadRetailerList} disabled={state.RetailerData?.length === 0 || nodata || !fromDate || !toDate}>
                          <img src={Image_Url.EXCEL_LOGO} className="downloads_imgdexcel" />
                          Download Excel
                        </button>
                      </div>
                    </div>
                    <div className="tabledata">
                      {state.RetailerData?.length > 0 ?
                        <div>
                          <table className="table">
                            <tr>
                              <th className="tablesth">Retailer Name</th>
                              <th className="tablesth">Mobile Number</th>
                              <th className="tablesth">Pincode</th>
                              <th className="tablesth">Aps Name</th>
                              <th className="tablesth">Shop Name</th>
                              <th className="tablesth">Created On</th>
                              <th className="tablesth">Registered On</th>
                              <th className="tablesth">Customer Code</th>
                              <th className="tablesth">POMS Linking Status</th>
                              <th className="tablesth">Location</th>
                              <th className="tablesth">Action</th>
                            </tr>
                            {state.RetailerData?.map((item, index) => {
                              return (
                                <tr>
                                  <td className="tabletd-pgmlist query_text" key={index} title={item?.name}>{item?.name}</td>
                                  <td className="tabletd-pgmlist">{item?.mobile_number}</td>
                                  <td className="tabletd-pgmlist">{item?.pincode}</td>
                                  <td className="tabletd-pgmlist query_text" title={item?.aps_name}>{item?.aps_name}</td>
                                  <td className="tabletd-pgmlist query_text" title={item?.garage_name}>{item?.garage_name}</td>
                                  <td className="tabletd-pgmlist">{item?.created_on}</td>
                                  <td className="tabletd-pgmlist">{item?.registered_on}</td>
                                  <td className="tabletd-pgmlist query_text" title={item?.customer_codes || "-----"}>{item?.customer_codes || "-----"}</td>
                                  <td className="tabletd-pgmlist query_text" title={String(item?.is_retailer_linked ?? "-----")}>{item?.is_retailer_linked ?? "-----"}</td>
                                  <td className="tabletd-pgmlist query_text" title={item?.state_name}>{item?.state_name}</td>
                                  <td className="tabletdV">
                                    <div className="card_profile_controls">
                                      <IoMdInformationCircleOutline className="infomation-icons"
                                        onClick={() => {
                                          retailerDetails(item.id);
                                        }} />
                                    </div>

                                  </td>
                                </tr>
                              );
                            })}
                          </table>
                        </div>
                        :
                        <div>
                          {nodata && (<NoDataFound />)}
                        </div>
                      }
                    </div>
                    <div className="Pagination_section">
                      <Stack spacing={2}>
                        <Pagination
                          count={count}
                          className="pagination"
                          page={page}
                          size="medium"
                          defaultPage={1}
                          color="primary"
                          onChange={handlePaginationChange}
                        />
                      </Stack>
                      <div className="count">
                        <b>
                          <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                        </b>
                      </div>
                    </div>
                  </div>
                  : (
                    <Nopermission />
                  )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>

  );
}
export default RetailerList;